/**
 * Hub Resources hosts register tab switches for 20.1 / 20.2 tours.
 */

export type FocResHubTourApi = {
  showResources: () => void;
  setResourcesTab: (tab: 'resource' | 'request' | 'ics211') => void;
};

let api: Partial<FocResHubTourApi> = {};
let pendingPrepare: (() => void) | null = null;

export function registerFocResHubTourApi(
  partial: Partial<FocResHubTourApi>
): () => void {
  api = { ...api, ...partial };
  if (pendingPrepare) {
    const run = pendingPrepare;
    pendingPrepare = null;
    run();
  }
  return () => {
    for (const key of Object.keys(partial) as (keyof FocResHubTourApi)[]) {
      if (api[key] === partial[key]) {
        delete api[key];
      }
    }
  };
}

export function getFocResHubTourApi(): Partial<FocResHubTourApi> {
  return api;
}

export function prepareFocResHubStep(surface?: string) {
  const host = getFocResHubTourApi();
  if (!host.showResources && !host.setResourcesTab) {
    pendingPrepare = () => prepareFocResHubStep(surface);
    return;
  }
  host.showResources?.();
  if (surface === 'requests') {
    host.setResourcesTab?.('request');
    return;
  }
  if (surface === 'ics211') {
    host.setResourcesTab?.('ics211');
    return;
  }
  host.setResourcesTab?.('resource');
}

export function resetFocResHubTourBridgeForTests() {
  api = {};
  pendingPrepare = null;
}
